import axios from "axios";
import MainService from "./MainService";

export default class GuideService extends MainService {
    constructor() {
		super();
		this.url = `${this.apiUrl}/guides`;
	}

    list() {
        return axios.get(this.url);
    }

    filter(filter) {
        return axios.post(`${this.url}/filter`, filter);
    }

    get() {
        return axios.get(`${this.url}`);
    }

    update(guide) {
        return axios.put(`${this.url}/`, guide);
    }

    sendResetPassword(email) {
        return axios.put(
            `${this.url}/email/reset-password`,
            JSON.stringify(email),
            { headers: { "Content-Type": "application/json" }
        });
    }

    changePassword(changePassword) {
        return axios.put(`${this.url}/password`, changePassword);
    }

    acceptTerms() {
        return axios.put(`${this.url}/terms-accepted`);
    }

    manual() {
        return axios.get(`${this.url}/manual`);
    }
}



// WEBPACK FOOTER //
// ./src/service/GuideService.js